// ** MUI Imports
import { Theme } from '@mui/material/styles'

// ** Theme Type Import
import { Skin } from 'src/@core/layouts/types'
import { foundationTokens } from 'src/components/foundations'

const Popover = (theme: Theme, skin: Skin) => {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          '& .MuiPopover-paper': {
            borderRadius: foundationTokens.radius.control,
            boxShadow: theme.shadows[skin === 'bordered' ? 0 : foundationTokens.shadow.floating],
            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
          }
        }
      }
    }
  }
}

export default Popover
